import { Compute } from './ComputedVariable';
import { ComputeHash } from './ComputedVariableHash';
var ComputedVariable = {
    getters: {
        Compute: Compute,
        ComputeHash: ComputeHash,
    },
};
export { ComputedVariable };
